import { createSelector } from "reselect";
import { isEmpty } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => {
  const selectedId = state.messaging.chat.id;
  const conversations = state.messaging.conversations;
  if (selectedId === null) {
    return undefined;
  }
  if (isEmpty(conversations)) {
    return undefined;
  }

  const info = conversations[selectedId];
  if (isEmpty(info)) {
    return undefined;
  }
  return info.user;
};

const getSelectedChatCachedUser = createSelector(
  getData,
  cachedUser => cachedUser
);

export default getSelectedChatCachedUser;



// WEBPACK FOOTER //
// ./src/_selectors/messagingSelectors/getSelectedChatCachedUser.js